import React, { Component } from 'react';
import { connect } from 'react-redux';

import {performRequest} from './actions.mjs';
import EventTitle from './EventTitle';
import EventItem from './EventItem';
import EventLoadMore from './EventLoadMore'; 

class EventList extends Component {
  constructor(props) {
      super(props);
  }

  componentDidMount() {
    this.props.dispatch(performRequest());
  }
    render() {
        return (
            <div>
                <EventTitle title={this.props.title} />
                
                <div className="container listings__items">
                    {this.props.eventHits.map((hit, index) => {
                        return (
                        <EventItem key={index} hit={hit} />
                        );
                    })}

                </div>
                <EventLoadMore/>
           </div>
        );
    }
}
function mapStateToProps(state) {
  return {
      eventHits: state.results.eventHits,
      title: state.title
  };
}

export default connect(mapStateToProps)(EventList);
